export const LogoList = {
    telekommalaysia : { logo : 'assets/logos/telekommalaysia.png' , height: '100px' },
    entegresolar : { logo : 'assets/logos/entegresolar.png' , height: '100px' }
}